import { mapState } from 'vuex';
import InstallationFeatures from '@/components/InstallationFeatures';
import { APIError } from '../plugins/Api';

export default {
  computed: {
    ...mapState(['config']),
  },
  methods: {
    async installApp(id, type, {
      isFromRepo, link, name, image, version, installationTicket, showSuccessConfirm = true, asIpaFile, featuresConfirmText,
    } = {}) {
      if (!this.$store.getters.isDeviceLinked) {
        await this.$confirm(this.$t('GO_TO_LINK_QUESTION'));
        this.$router.push('/link');
        throw new Error('No device linked');
      }

      if (!asIpaFile && !this.$store.getters.canInstallApps) {
        await this.$alert(this.$t('TO_INSTALL_VISIT_FROM_DEVICE', { device: this.config.nice_idevice_model }));
        throw new Error('Can\'t install on current device');
      }

      const features = await this.getFeaturesConfig({ confirmText: featuresConfirmText });

      try {
        const response = await this.$api.installApp({
          id, type, features, isFromRepo, link, name, image, version, installationTicket, asIpaFile,
        });

        // Check if installation was cancelled
        if (response && response.cancelled) {
          console.log('[DEBUG] Installation was cancelled by user in mixin, stopping process');
          return { cancelled: true };
        }

        if (!asIpaFile && response && response.data && response.data.installation_type === 'itms-services') {
          this.$router.push({
            path: '/install',
            query: {
              commandUuid: response.data.command_uuid,
              historyUuid: response.data.installation_history_uuid,
              askForJit: response.data.supports_jit,
            },
          });
          return;
        }

        if (showSuccessConfirm) {
          try {
            await this.$confirm(this.$t('INSTALL_APP_CONFIRMATION'));
          } catch {
            this.$router.push('/my/status');
          }
        }

        return response;
      } catch (error) {
        if (error instanceof APIError) {
          this.$notify({
            type: 'error',
            text: error.translatedMessage,
          });

          if (error.code === 'ERROR_FREE_DEVELOPER_UNSUPPORTED_IOS_VERSION') {
            await this.$confirm(this.$t('PLUS_OBTAIN_CONFIRM'));
            this.$router.push('/my/faq');
          }

          return;
        }

        this.$notify({
          type: 'error',
          text: this.$t('SOMETHING_WENT_WRONG'),
        });
      }
    },
    async getFeaturesConfig({ confirmText }) {
      if (this.config.ask_for_installation_options !== 'yes') {
        return {};
      }

      const features = await this.$api.getInstallFeatures();
      const config = await new Promise((resolve, reject) => {
        this.$modal.show(InstallationFeatures, {
          features,
          resolve,
          reject,
          confirmText,
        }, {
          classes: 'features-modal',
          height: 'auto',
          width: '100%',
          maxWidth: 600,
          scrollable: true,
          clickToClose: false,
        });
      });

      return config;
    },
  },
};
